import { createFileRoute, redirect } from "@tanstack/react-router";
import { INTRO_OFFERS_ENABLED } from "@/lib/introPassPath";
import { CourseTrial } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";
import appCss from "@/styles/app.css?url";

export const Route = createFileRoute("/course-trial/$courseId")({
  // ₹99 trials are paused: send old links to Annual checkout.
  beforeLoad: () => {
    if (!INTRO_OFFERS_ENABLED) throw redirect({ to: "/membership-checkout", search: { plan: "annual" } as never });
  },
  head: () => {
    const head = seoHead({ title: "Course Trial", noindex: true });
    return { ...head, links: [...head.links, { rel: "stylesheet", href: appCss }] };
  },
  component: CourseTrial,
});
